// EmptyState.jsx
import { Inbox } from 'lucide-react';

export default function EmptyState({ onRequestLeave }) {
  return (
    <div className="py-16 text-center">
      <Inbox className="mx-auto h-16 w-16 text-gray-300" />
      <h3 className="mt-4 text-lg font-medium text-gray-900">No leave requests</h3>
      <p className="mt-1 text-gray-500">Get started by requesting time off</p>
      <button
        onClick={onRequestLeave}
        className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
      >
        Request Leave
      </button>
    </div>
  );
}
